import React, { useEffect, useState } from "react";
import { FxCompanyPopup } from "../../fxms/components/FxCompanyPopup";

/**
 *
 * @param {*} props
 * @returns
 */
export const UI_0_2 = (props) => {

  const inloNo = JSON.parse(localStorage.getItem("filterDate")).inloNo;
  const prodDateStart = JSON.parse(localStorage.getItem("filterDate")).prodDateStart;
  const prodDateEnd = JSON.parse(localStorage.getItem("filterDate")).prodDateEnd;

  return (
    <>
      <FxCompanyPopup
        engId={'COOLWATER'}
        inloNo={inloNo}
        prodDateStart={prodDateStart}
        prodDateEnd={prodDateEnd}
        engAddName={"냉수적산"}
        engUnitName={"ton"}
        color={"#ff7600"}
      />
      <FxCompanyPopup
        engId={'AIR'}
        inloNo={inloNo}
        prodDateStart={prodDateStart}
        prodDateEnd={prodDateEnd}
        engAddName={"압공적산"}
        engUnitName={"Nm³"}
        color={"#7b7b7b"}
      />
      <FxCompanyPopup
        engId={'STEAM'}
        inloNo={inloNo}
        prodDateStart={prodDateStart}
        prodDateEnd={prodDateEnd}
        engAddName={"스팀적산"}
        engUnitName={"ton"}
        color={"#03bcff"}
      />
    </>
  )
}